export default Object.freeze({
	sceneReady: 'sceneReady',
	modelsPreloaded: 'modelsPreloaded',
	onPointerOverNode: 'onPointerOverNode',
	onPointerOverGround: 'onPointerOverGround',
	onCollision: 'onCollision',
	onCollisionEnd: 'onCollisionEnd',
	onCameraUpdated: 'onCameraUpdated',
	onSceneResized: 'onSceneResized',
});
